import { IStatusPanelAngularComp } from '@ag-grid-community/angular';
import { IStatusPanelParams } from '@ag-grid-community/core/dist/esm/es6/interfaces/iStatusPanel';
import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { IMAGES } from 'shared/constants/imagePaths.constants';

@Component({
    selector: 'app-status-bar-logo-container',
    templateUrl: './status-bar-logo-container.component.html',
    styleUrl: './status-bar-logo-container.component.scss',
    imports: [NgOptimizedImage],
})
export class StatusBarLogoContainerComponent implements IStatusPanelAngularComp {
    protected IMAGES = IMAGES;
    private params!: IStatusPanelParams;

    public agInit(params: any): void {
        this.params = params;
    }
}
